<template>
  <v-text-field
    ref="field"
    v-bind="$attrs"
    v-maska="mask"
    :model-value="modelValue"
    :rules="getRules"
    variant="outlined"
    :bg-color="backgroundColor"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script setup lang="ts">
import { computed, ref, type Ref } from "vue";
import { ValidationRule } from "vuetify";
import { VTextField } from "vuetify/components";
import { useRules } from "vuetify/labs/rules";

interface Props {
  backgroundColor?: string;
  required?: boolean;
  rules?: ValidationRule[];
  mask?: string | null;
  modelValue?: string | number | null;
}

const {
  backgroundColor = "white",
  required = false,
  rules = [],
  mask = null,
  modelValue = null,
} = defineProps<Props>();

defineEmits<{
  "update:modelValue": [value: string | number | null];
}>();

defineOptions({
  name: "TTextInput",
  inheritAttrs: false,
});

// Template ref for the text field
const field: Ref<InstanceType<typeof VTextField> | undefined> = ref();

// Computed rules
const getRules = computed<ValidationRule[]>(() => {
  return [
    ...(required ? [ useRules().required("Este campo é obrigatório") ] : []),
    ...rules,
  ];
});

// Expose validate method for parent components
function validate(): Promise<boolean | string[]> {
  if (!field.value) return Promise.resolve(false);

  return field.value.validate(true);
}

defineExpose({
  validate,
});
</script>
